import { useMenuSrch } from 'api/common/menusrch-fetch.js'
import { InfoList, List, ListTitle, SearchBar, Text } from 'components'
import { APP_INFO_CONST } from 'constants/app_info_const'
import { queryClient } from 'index'
import { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'
import { userInfoState } from 'store/atom/user-state-atom'
import { formatStringDate } from 'utils/format-util'

// css
import 'assets/style/common.scss'
import useModal from 'hook/useModal'
import { isEmptyString } from 'utils/common-util'

function RelatedMenu({ keyword = '', menuType = '', ok = () => {} }) {
  const [total, setTotal] = useState(0)
  const { alertModal } = useModal()
  const userInfo = useRecoilValue(userInfoState)

  const [queryOptions, setQueryOptions] = useState({
    size: APP_INFO_CONST.PAGE_SIZE,
    page: 1,
    coId: userInfo.coId,
    siteId: userInfo.siteId,
    keyword: keyword,
    menuType: menuType,
    lastMenuIdSeq: '',
    hasNext: false,
  })

  const { isSuccess, data, fetchNextPage, hasNextPage, refetch } = useMenuSrch(queryOptions, false)

  useEffect(() => {
    return () => {
      queryClient.removeQueries('menuSrch')
    }
  }, [])

  useEffect(() => {
    if (!isEmptyString(queryOptions.keyword)) {
      if (queryOptions.hasNext) {
        fetchNextPage()
      } else {
        refetch()
      }
    }
  }, [queryOptions])

  useEffect(() => {
    if (isSuccess) {
      setTotal(data?.pages[0].lastRow)
    }
  }, [data])

  const goSearch = (value) => {
    if (isEmptyString(value)) {
      alertModal('검색어를 입력해주세요.')
      return
    }
    setQueryOptions({
      ...queryOptions,
      keyword: value,
      lastMenuIdSeq: '',
      hasNext: false,
    })
  }

  const checkRecommend = (item) => {
    if (item.phbtYn === 'Y' /* item.gdUsSttsCd === '2' */) {
      return [{ id: 'recommend', text: '금지', color: 'fullred' }]
    } else if (item.monthYn === 'Y') {
      return [{ id: 'recommend', text: '월간요리', color: 'gray' }]
    } else if (item.newMenuYn === 'Y') {
      return [{ id: 'recommend', text: 'NEW', color: 'green' }]
    } else if (item.menuType === '10') {
      return [{ id: 'recommend', text: '표준', color: 'gray' }]
    } else {
      return ''
    }
  }

  const nextPage = () => {
    const pageIndex = data.pages.length - 1
    const lastMenuIdSeq = data.pages[pageIndex].data[data.pages[pageIndex].data.length - 1].lastMenuIdSeq
    setQueryOptions({
      ...queryOptions,
      lastMenuIdSeq: lastMenuIdSeq,
      hasNext: true,
    })
  }

  return (
    <>
      {/* <Popup show={true} onCancel={handlePopup} title="알림내역"> */}
      <section className="wrapper">
        <Text text="메뉴명 또는 메뉴코드로 검색하세요." className="mb16 f-16 f-bold c-3 mt16" />
        <SearchBar goSearch={goSearch} keyword={keyword} />
        <ListTitle title="검색결과" count={total} className="mt16 mb8" />
      </section>

      {/* <Line size="1" color="gray" /> */}

      <section className="wrapper mt16" style={{ marginBottom: '20px' }}>
        <List onClick={nextPage} hasNextPage={hasNextPage} className="">
          {data?.pages?.map((pageData) =>
            pageData?.data?.map((item, index) => (
              <li
                key={`data_${index}`}
                className="border-gray mt8 border-radius-2 p12 bg-f"
                onClick={() => {
                  ok(item)
                }}
              >
                {/* <Tag data={checkRecommend(item)} /> */}
                <div className="flex">
                  <Text className="f-14 c-3 f-bold">
                    [{item.menuId}] {isEmptyString(item.menuAliNm) ? item.menuNm : item.menuAliNm}
                  </Text>
                  <span
                    className={item.menuType === '10' ? 'custom-badge-02' : 'custom-badge-01'}
                    style={{ height: '20px', marginLeft: '5px' }}
                  >
                    {item.menuType === '10' ? '표' : '사'}
                  </span>
                </div>
                <InfoList
                  level="2"
                  // className="mt4"
                  dataAlign="right"
                  spanMargin={'4px'}
                  data={[
                    { id: 1, title: '점포가', data: `${(item.trfUnprc || 0).toLocaleString()} 원` },
                    { id: 2, title: '최근제공일', data: formatStringDate(item.lastestOfferDt) },
                    { id: 3, title: '비고', data: item.usfRsn },
                  ]}
                />
              </li>
            )),
          )}
        </List>
      </section>
    </>
  )
}

export default RelatedMenu
